<template>
  <el-dialog
            title="Create Company"
            :visible.sync="innerValue"
            width="530px"
            height="100%"
            :close-on-click-modal=false
            :close-on-press-escape=false
            v-loading="loading"
  >
    <el-card class="box-card">
      <el-form>
        <el-form-item label="Company Name">
          <el-input v-model="companyName"></el-input>
        </el-form-item>
        <el-form-item label="BriteCore URL">
          <el-input v-model="britecoreURL" placeholder="https://..."></el-input>
        </el-form-item>

        <el-form-item label="BriteCore API Key">
          <el-input v-model="britecoreAPIKey"></el-input>
        </el-form-item>
      </el-form>
    </el-card>

    <div class="u-mt4">
      <el-button @click="createCompany" type="danger" class="display-block" :disabled="(!companyName || !britecoreURL || !britecoreAPIKey)">Create Company</el-button>
    </div>

  </el-dialog>
</template>

<script>

import {mapActions} from 'vuex'
import {axiosWrapper} from '@/shared/api.utils'
import config from '@/config'
import axios from 'axios'


export default {
  name: 'ba-foobar-dialog',
  components: {},
  props: {
    value: {type: Boolean},
  },
  watch: {
    value: {
      handler (value) {
        this.innerValue = value
      },
      immediate: true
    },
    innerValue: {
      handler (innerValue) {
        this.$emit('input', innerValue)
        this.$emit('change', innerValue)
      },
      immediate: true
    },
  },
  data () {
    return {
      companyName: null,
      britecoreURL: null,
      britecoreAPIKey: null,
      loading: false,
      innerValue: false,
    }
  },
  methods: {
    ...mapActions('login', ['init']),
    ...mapActions('shared', ['loadHealthcheck']),
    async createCompany () {
      this.loading = true

      try {
        await axiosWrapper(axios.post(
          `${config.url}/carrier-portal/create_company/`,
          {
            company_name: this.companyName,
            britecore_url: this.britecoreURL,
            britecore_api_key: this.britecoreAPIKey,
          }
        ))
        this.$alert(
          `Company created`,
          'Company was successfully created',
        )
      } catch (error) {
        this.$alert(
          error.response.message,
          'Failed to create company',
        )
        this.loading = false
        return
      }

      await this.init() // perform company refresh via carrier-user retrieval
      this.loadHealthcheck() // don't wait for Healthchecks
      this.clearData()
      this.innerValue = false
      this.loading = false
    },
    clearData () {
      this.companyName = null
      this.britecoreURL = null
      this.britecoreAPIKey = null
    }
  },
}
</script>
